import React from 'react'
import { VoiceList } from '@/components/newt/templates/VoiceList'
import { Voice } from '@/types/newt/voice'

interface VoiceGridProps {
  filteredVoice: Voice[]
}

export const VoiceGrid: React.FC<VoiceGridProps> = React.memo(
  ({ filteredVoice }) => {
    return (
      <div className="min-h-[380px]">
        <ul className="flex flex-col md:grid md:grid-cols-2 lg:grid-cols-3 gap-y-[30px] gap-x-[60px] mt-6 lg:mt-10">
          {filteredVoice.map((voiceItem) => (
            <VoiceList key={voiceItem._id} voice={voiceItem} />
          ))}
        </ul>
      </div>
    )
  }
)

VoiceGrid.displayName = 'VoiceGrid'
